import {Box, Typography} from "@mui/material"
import React from "react"
import {makeStyles} from "tss-react/mui"

interface KeyEventsStatisticsProps {
	warnings: number
	updates: number
}

const useStyles = makeStyles()({
	container: {
		display: "flex",
		padding: "0px 8px",
		justifyContent: "space-between",
		alignItems: "center",
		alignContent: "center",
		alignSelf: "stretch",
		flexWrap: "wrap",
	},
	title: {
		color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
		fontFeatureSettings: "'liga' off, 'clig' off",
		fontSize: "14px",
		fontStyle: "normal",
		fontWeight: 400,
		lineHeight: "143%",
		letterSpacing: "0.17px",
	},
	box: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: "4px",
	},
	divContainer: {
		display: "flex",
		alignItems: "center",
		gap: "8px",
	},
})

export default function KeyEventsStatistics(props: KeyEventsStatisticsProps) {
	const {classes} = useStyles()
	return (
		<div className={classes.container}>
			<Box className={classes.box}>
				<div className={classes.divContainer}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="13"
						height="12"
						viewBox="0 0 13 12"
						fill="none"
					>
						<circle cx="6.5" cy="6" r="6" fill="#FF9800" />
					</svg>
					<Typography className={classes.title}>{`Warnings: ${props.warnings}`}</Typography>
				</div>
				<div className={classes.divContainer}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="13"
						height="12"
						viewBox="0 0 13 12"
						fill="none"
					>
						<circle cx="6.5" cy="6" r="6" fill="#42A5F5" />
					</svg>
					<Typography className={classes.title}>{`Updates: ${props.updates}`}</Typography>
				</div>
			</Box>
		</div>
	)
}
